<template>
  <div id="orders" class="orders-view">
    <div class="orders-content">
      <table-fitrable
        v-if="isVisible"
        :data="orders"
        :posibleFilters="posibleFilters"
        :fields="visibleFields"
        :labels="names"
        :filters="filters"
        :integrity-data="integrityData"
        :loading="loading"
        @filtersChange="loadOrdersFilters"
        @reload="reload"
        @open="createModal"
      >
      </table-fitrable>
    </div>

    <div class="orders-pagination">
      <span class="orders-pagination__total"
        >Total {{ totalOrders }} órdenes</span
      >
      <el-pagination
        layout="prev, pager, next"
        :total="totalOrders"
        :page-size="100"
        :current-page="currentPage"
        :disabled="loading"
        @current-change="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import orderApi from "@/services/orders.api";
import apiToken from "@/components/utils/apiToken";
import TableFiltrableVue from "./TableFiltrable.vue";
import storage from "@/components/utils/storage";

const defaultFilters = {};
export default {
  name: "OrdersTable",
  components: {
    "table-fitrable": TableFiltrableVue,
  },
  data() {
    return {
      dialogVisible: false,
      orders: [],
      filters: { ...defaultFilters },
      recorders: [],
      posibleFilters: {},
      order: null,
      startOrder: null,
      isVisible: true,
      timer: {},
      integrityData: [],
      currentPage: 1,
      totalOrders: 0,
      loading: false,
    };
  },
  computed: {
    ...mapState("config", ["names", "visibleFields"]),
  },
  created() {
    this.loadrecorderNames();
    const saved = storage.loadInfoFilter();
    if (saved) {
      this.filters = { ...this.filters, ...saved };
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    reload() {
      this.isVisible = false;
      setTimeout(() => {
        this.isVisible = true;
      }, 5);
    },
    async onPageChange(p) {
      this.currentPage = p;
      this.loading = true;
      try {
        await this.loadOrders();
      } finally {
        this.loading = false;
      }
    },
    eventPlay(evnt) {
      evnt();
    },
    createModal({ order, videoStart }) {
      this.order = order;
      this.startOrder = videoStart;
      this.dialogVisible = true;
    },
    async loadOrders() {
      var self = this;
      try {
        const apiFilters = { ...this.filters };
        delete apiFilters.recorderName;
        const result = await orderApi.fetchByFilters(
          apiFilters,
          null,
          this.currentPage
        );
        this.$set(this, "orders", result.items);
        this.totalOrders = result.totalCount;
        this.integrityData = result.items.map(
          (o) => o.videoMinutesPercentage ?? 0
        );
      } catch (error) {
        if (error && error.response && error.response.status === 401) {
          apiToken.tokenExpire(self);
        } else if (error && error.response && error.response.status === 403) {
          window.location = "/denied";
        }
      }
    },
    resetFilters() {
      for (let filterKey of this.visibleFields) {
        this.filters[filterKey] = defaultFilters[filterKey] || "";
      }
    },
    getDateRangeFromFilters() {
      const range = this.filters.videoStart;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        return { start_date: range[0], end_date: range[1] };
      }
      return null;
    },
    setPosibleFilters(raw) {
      const normalized = {};
      Object.entries(raw).forEach(([apiKey, values]) => {
        const fieldKey = apiKey.charAt(0).toLowerCase() + apiKey.slice(1);
        normalized[fieldKey] = values;
      });
      if (!normalized.recorderName && this.posibleFilters.recorderName) {
        normalized.recorderName = this.posibleFilters.recorderName;
      }
      this.posibleFilters = normalized;
    },
    async loadPosibleFilters() {
      try {
        const dateRange = this.getDateRangeFromFilters();
        const raw = await orderApi.fetchDataFilters(dateRange);
        this.setPosibleFilters(raw);
        Object.keys(this.posibleFilters).forEach((key) => {
          if (this.filters[key] === undefined) {
            this.$set(this.filters, key, []);
          }
        });
      } catch (err) {
        console.error("Error cargando filtros:", err);
        if (err.response?.status === 401) {
          apiToken.tokenExpire(this);
        } else if (err.response?.status === 403) {
          window.location = "/denied";
        }
      }
    },
    async loadOrdersFilters(newFilters) {
      try {
        this.loading = true;
        if (newFilters && typeof newFilters === "object") {
          const transformedFilters = { ...newFilters };
          if (transformedFilters.recorderName) {
            if (transformedFilters.recorderName.length > 0) {
              if (!this.recorders || this.recorders.length === 0) {
                this.recorders = await orderApi.getrecorders();
              }
              transformedFilters.recorderId =
                transformedFilters.recorderName.map((name) => {
                  const recorder = this.recorders.find((f) => f.name === name);
                  return recorder ? recorder.identifier : name;
                });
            } else {
              transformedFilters.recorderId = [];
            }
          }
          this.filters = { ...this.filters, ...transformedFilters };
          storage.saveInfoFilter(this.filters);
        }
        this.currentPage = 1;
        await Promise.all([this.loadOrders(), this.loadPosibleFilters()]);
      } finally {
        this.loading = false;
      }
    },
    async loadrecorderNames() {
      try {
        this.recorders = await orderApi.getrecorders();
        const recorderNames = this.recorders.map((f) => f.name);
        this.$set(this.posibleFilters, "recorderName", recorderNames);
      } catch (error) {
        console.error("Error cargando nombres de carretillas:", error);
        this.$message.error("Error al cargar las carretillas disponibles");
      }
    },
  },
};
</script>

<style>
.orders-view {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 58px);
  background-color: #f0f4f8;
}

.orders-content {
  flex: 1;
  overflow-y: auto;
  padding: clamp(10px, 2vw, 20px) clamp(10px, 2.5vw, 22px) 0;
}

/* ── PAGINACIÓN ────────────────────────────────────────────────── */
.orders-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: clamp(6px, 1.2vw, 10px) clamp(10px, 2.5vw, 22px);
  margin: clamp(6px, 1.2vw, 12px) clamp(10px, 2.5vw, 22px);
  background: transparent;
  flex-wrap: wrap;
  gap: 8px;
}

.orders-pagination__total {
  color: #64748b;
  font-size: clamp(11px, 1.2vw, 12px);
  font-family: "Roboto", sans-serif;
}

/* Botones prev / next */
.orders-pagination .el-pagination {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}

.orders-pagination .el-pagination .btn-prev,
.orders-pagination .el-pagination .btn-next {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #64748b;
  width: 36px;
  height: 36px;
  min-width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.orders-pagination .el-pagination .btn-prev:hover,
.orders-pagination .el-pagination .btn-next:hover {
  border-color: #0284c7;
  color: #0284c7;
}

.orders-pagination .el-pagination .btn-prev .el-icon,
.orders-pagination .el-pagination .btn-next .el-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  font-size: 12px;
}

/* Números de página */
.orders-pagination .el-pagination .el-pager {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
}

.orders-pagination .el-pagination .el-pager li {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #64748b;
  font-size: 12px;
  font-weight: 400;
  width: 36px;
  height: 36px;
  min-width: 36px;
  margin: 0 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.orders-pagination .el-pagination .el-pager li.active {
  background: #0284c7;
  border-color: #0284c7;
  color: #fff;
  font-weight: 600;
}

.orders-pagination .el-pagination .el-pager li:hover {
  border-color: #0284c7;
  color: #0284c7;
}

/* ── RESPONSIVE: tablet ────────────────────────────────────────── */
@media (max-width: 768px) {
  .orders-pagination {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .orders-pagination__total {
    font-size: 12px;
  }

  /* Botones de paginación más grandes para táctil */
  .orders-pagination .el-pagination .btn-prev,
  .orders-pagination .el-pagination .btn-next {
    width: 40px;
    height: 40px;
    min-width: 40px;
  }

  .orders-pagination .el-pagination .el-pager li {
    width: 40px;
    height: 40px;
    min-width: 40px;
    font-size: 13px;
  }
}

/* ── RESPONSIVE: móvil ─────────────────────────────────────────── */
@media (max-width: 480px) {
  .orders-content {
    padding: 8px 8px 0;
  }

  .orders-pagination {
    margin: 6px 8px;
    padding: 6px 8px;
  }
}
</style>
